"use strict";
/*
* Created on 20.06.2019
*/

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var utils_1 = require("../../core/utils");

var WindowItemPlacement_1 = require("../model/WindowItemPlacement");

var WindowItemPlacementConverter_1 = require("./WindowItemPlacementConverter");
/**
 * @author Stepan Mik
 */


var WindowItemPlacementConverterImpl =
/*#__PURE__*/
function (_WindowItemPlacementC) {
  _inherits(WindowItemPlacementConverterImpl, _WindowItemPlacementC);

  function WindowItemPlacementConverterImpl() {
    _classCallCheck(this, WindowItemPlacementConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPlacementConverterImpl).apply(this, arguments));
  }

  _createClass(WindowItemPlacementConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      if (!utils_1.Utils.isObject(source['placements'])) {
        throw new Error('Missing placements field or invalid type');
      }

      var placements = source['placements'];
      var map = immutable_1.Map();

      for (var k in placements) {
        if (placements.hasOwnProperty(k)) {
          var ids = utils_1.Utils.asArray(placements[k]).map(function (a) {
            return conversions.toClassReferenceId(a) || utils_1.Utils.fail('Null ids not supported');
          });
          map = map.set(k, immutable_1.Set(ids));
        }
      }

      return new WindowItemPlacement_1.WindowItemPlacement(conversions.documentToClassId(source), conversions.toClassReferenceId(source['windowItemId']) || utils_1.Utils.fail('Empty WI ID'), map);
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var placements = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              set = _step$value[1];

          var ids = [];
          set.forEach(function (sid) {
            return ids.push(conversions.toDocumentReferenceId(sid));
          });
          placements[key] = ids;
        };

        for (var _iterator = source.placements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId),
        placements: placements
      });
      return result;
    }
  }]);

  return WindowItemPlacementConverterImpl;
}(WindowItemPlacementConverter_1.WindowItemPlacementConverter);

exports.WindowItemPlacementConverterImpl = WindowItemPlacementConverterImpl;